
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M17.5 14.25V13H18.6L19.32 14.59C19.43 14.84 19.68 15 19.95 15C20.45 15 20.78 14.49 20.59 14.04L20.1 12.9C20.6 12.6 21 12.1 21 11.5V10.5C21 9.67 20.33 9 19.5 9H17C16.45 9 16 9.45 16 10V13.9L17.04 14.94C17.31 14.83 17.5 14.56 17.5 14.25ZM17.5 10.5H19.5V11.5H17.5V10.5ZM13 10.5V10.9L14.5 12.4V10.5C14.5 9.68 13.82 9 13 9H11.1L12.6 10.5H13ZM21.03 21.03L3.02995 3.03C2.73995 2.74 2.26995 2.74 1.97995 3.03C1.68995 3.32 1.68995 3.79 1.97995 4.08L6.95995 9.06C6.68995 9.17 6.49995 9.44 6.49995 9.75V11H4.49995V9.75C4.49995 9.34 4.15995 9 3.74995 9C3.33995 9 2.99995 9.34 2.99995 9.75V14.25C2.99995 14.66 3.33995 15 3.74995 15C4.15995 15 4.49995 14.66 4.49995 14.25V12.5H6.49995V14.25C6.49995 14.66 6.83995 15 7.24995 15C7.65995 15 7.99995 14.66 7.99995 14.25V10.1L9.49995 11.6V14.5C9.49995 14.78 9.71995 15 9.99995 15H12.5C12.62 15 12.74 14.99 12.86 14.96L19.9699 22.07C20.26 22.36 20.7299 22.36 21.02 22.07C21.31 21.79 21.31 21.32 21.03 21.03Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-hdr-off`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconHdrOff

    ```js
    <b-new-b-icon-hdr-off />
    ```
</docs>


